<template>
  <div class="Box">
   
    <el-card class="box-card">
       <div class="hz_all">
        <div class="hz_left">
       <div class="titleText">查询总充值</div>
        <div class="moneyText" style="color: #50c219;">{{total_recharge_money}}元</div>
      </div>
      <div class="hz_left">
        <div class="titleText">当日总充值</div>
        <div class="moneyText">{{today_recharge_money}}元</div>
      </div>
      <div class="hz_left">
       <div class="titleText">当月总充值</div>
        <div class="moneyText" style="color: #50c219;">{{monthly_recharge_money}}元</div>
      </div>
      
    </div>
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35" style="display: flex;flex-wrap: wrap;">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="商户单号">
              <el-input v-model="queryParams.trade_no" placeholder="请输入商户单号" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="交易单号">
              <el-input v-model="queryParams.payment_order_no" placeholder="请输入交易单号" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="充值金额">
              <el-input v-model="queryParams.money" placeholder="请输入充值金额" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台类型">
              <el-select v-model="queryParams.platform_type" class="w100" @change="search" @clear="search" clearable placeholder="请选择平台类型">
                <el-option label="全部" :value="0"></el-option>
     
                <el-option label="微信" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="支付状态">
              <el-select v-model="queryParams.state" class="w100" @change="search" @clear="search" clearable placeholder="请选择支付状态">
                <el-option label="未支付" :value="0"></el-option>
                <el-option label="已支付" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="退款状态">
              <el-select v-model="queryParams.refund" class="w100" @change="search" @clear="search" clearable placeholder="请选择退款状态">
                <el-option label="未退款" :value="0"></el-option>
                <el-option label="退款中" :value="1"></el-option>
                <el-option label="退款成功" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="渠道号">
              <SelectChecked :options="referralOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择渠道号"
                             @selectedVal="selectedReferral" :search="search"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户ID">
              <el-input v-model="queryParams.user_id" placeholder="请输入用户ID" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="巨量广告ID">
              <el-input v-model="queryParams.ad_id" placeholder="请输入广告ID" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="注册时间">
              <el-date-picker
                  style="width: 100%"
                  v-model="queryParams.user_createtime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  @change="handTimeZhuce"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="下单时间">
              <el-date-picker
                  @change="handTime"
                  style="width: 100%"
                  v-model="queryParams.created_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="完成时间">
              <el-date-picker
                  @change="handTimeSucces"
                  style="width: 100%"
                  v-model="queryParams.finistime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="优化师ID">
              <el-input v-model="queryParams.optimizer_id" @change="search" @clear="search" placeholder="请输入优化师ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="优化师昵称">
              <el-input v-model="queryParams.optimizer_nickname" @change="search" @clear="search" placeholder="请输入优化师昵称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小程序名称">
              <el-select v-model="queryParams.app_id" class="w100" @change="search" @clear="search" clearable placeholder="请选择小程序名称">
                <el-option v-for="dict in appList" :key="dict.uuid" :label="dict.platform_type_text + '-' + dict.name"
                           :value="dict.uuid"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="mb20">
            <el-button size="medium" type="primary" @click="search">查询</el-button>
            <el-button size="medium" @click="addNoNe">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加导出</el-button> 
        <!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <el-table
          ref="multipleTable"
          :data="tableData"
          :summary-method="getSummaries"
                show-summary
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          size="medium"
          @selection-change="handleSelectionChange"
          border
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          v-loading="loading"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column label="商户单号" width="230">
          <template slot-scope="scope">{{ scope.row.trade_no }}</template>
        </el-table-column>
        <el-table-column label="交易单号" width="280">
          <template slot-scope="scope">{{ scope.row.payment_order_no }}</template>
        </el-table-column>

        <el-table-column label="用户ID">
          <template slot-scope="scope">{{ scope.row.user_id }}</template>
        </el-table-column>
        <el-table-column label="用户注册时间" width="180">
          <template slot-scope="scope">{{ scope.row.user_createtime }}</template>
        </el-table-column>
        <el-table-column label="用户染色时间" width="180">
          <template slot-scope="scope">{{ scope.row.dyed_at }}</template>
        </el-table-column>
        <el-table-column label="支付方式">
          <template slot-scope="scope">{{ scope.row.type_text }}</template>
        </el-table-column>
        <el-table-column label="充值类型">
          <template slot-scope="scope">{{ scope.row.pay_type_remark }}</template>
        </el-table-column>
        <el-table-column label="充值金额">
          <template slot-scope="scope">{{ scope.row.money }}</template>
        </el-table-column>
        <!-- <el-table-column label="染色充值次数">
          <template slot-scope="scope">{{ scope.row.recharge_num }}</template>
        </el-table-column> -->
        <el-table-column label="充值次数">
          <template slot-scope="scope">{{ scope.row.pay_count }}</template>
        </el-table-column>
        <el-table-column label="支付状态">
          <template slot-scope="scope">{{ scope.row.state_text }}</template>
        </el-table-column>
        <!-- <el-table-column label="退款状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state==1">{{ scope.row.refund_text }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column label="下单时间" width="180">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>
        <el-table-column label="完成时间" width="180">
          <template slot-scope="scope">{{ scope.row.finistime }}</template>
        </el-table-column>
        <el-table-column label="作品ID">
          <template slot-scope="scope">{{ scope.row.book_id }}</template>
        </el-table-column>
        <el-table-column label="作品名称" width="180">
          <template slot-scope="scope">{{ scope.row.book_name }}</template>
        </el-table-column>
        <el-table-column label="平台">
          <template slot-scope="scope">{{ scope.row.platform_type_text }}</template>
        </el-table-column>
        <el-table-column label="小程序包名" width="180">
          <template slot-scope="scope">{{ scope.row.appname }}</template>
        </el-table-column>
        <el-table-column label="渠道号" width="150">
          <template slot-scope="scope">{{ scope.row.channel_code }}</template>
        </el-table-column>
        <el-table-column label="推广链接名称">
          <template slot-scope="scope">{{ scope.row.channel_name }}</template>
        </el-table-column>
        <el-table-column label="投放类型" width="180">
          <template slot-scope="scope">{{ scope.row.launch_type_text }}</template>
        </el-table-column>
        <!-- <el-table-column label="广告ID" width="170">
          <template slot-scope="scope">{{ scope.row.ad_id }}</template>
        </el-table-column> -->
        <el-table-column label="优化师ID">
          <template slot-scope="scope">{{ scope.row.optimizer_id }}</template>
        </el-table-column>
        <el-table-column label="优化师昵称" width="180">
          <template slot-scope="scope">{{ scope.row.optimizer_nickname }}</template>
        </el-table-column>
        <el-table-column label="巨量广告ID" width="170">
          <template slot-scope="scope">{{ scope.row.ad_id }}</template>
        </el-table-column>
        <el-table-column label="回传状态" width="170">
          <template slot-scope="scope">{{ scope.row.callback_text }}</template>
        </el-table-column>
        <el-table-column label="未传原因" width="170">
          <template slot-scope="scope">{{ scope.row.callback_message }}</template>
        </el-table-column>
        <el-table-column label="ip" width="170">
          <template slot-scope="scope">{{ scope.row.ip }}</template>
        </el-table-column>
        
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.state==1&&scope.row.refund!=1&&scope.row.refund!=2" -->
            <el-button type="text" v-if="scope.row.callback==0&&scope.row.clickid" size="medium" @click="bcbtn(scope.row)">补传
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getOrderList"/>

      <el-dialog :close-on-click-modal="false" width="40%" title="退款" :visible.sync="dialogFormVisible"
                 :before-close="handleClose">
        <el-form ref="ruleForm" :model="formRefund" :rules="rules" size="medium">
          <el-form-item label="退款原因:" label-width="90px" prop="reason">
            <el-input v-model="formRefund.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitFormRefund">确 定</el-button>
        </div>
      </el-dialog>

    </el-card>
  </div>
</template>
<script>
import {OrderApi} from '@/api/Order/index';
import {Session} from '@/utils/storage';
import {appListAPI} from '@/api/appletlist/applist/index';
import {processErrors} from '@/utils/errorHandler';
import {GeneralCollectApi} from '@/api/statistics/comStatistics/index';
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  name: 'OrderDetils',
  components: {
    SelectChecked
  },
  data() {
    return {
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        trade_no: '',
        order_id: '',
        payment_order_no: '',
        money: '',
        state: '',
        platform_type: '',
        app_id: '',
        optimizer_id: '',
        optimizer_nickname: '',
        channel_code: '',
        user_id: '',
        ad_id: '',
        user_createtime: [],
        created_at: [],
        finistime: [],
      },
      daochuList: {
        trade_no: '',
        order_id: '',
        payment_order_no: '',
        money: '',
        state: '',
        platform_type: '',
        app_id: '',
        optimizer_id: '',
        optimizer_name: '',
        channel_code: '',
        user_id: '',
        ad_id: '',
        user_createtime: '',
        finistime: '',
        created_at: [],
      },
      dialogVisible: false,
      tableData: [],
      total: 0,
      multipleSelection: [],
      appList: [
        {
          uuid: 0,
          name: '请选择小程序名称',
          platform_type_text: '平台',
        },
      ],
      loading: false,
      dialogFormVisible: false,
      formRefund: {
        reason: '',
      },
      rules: {
        reason: [
          {required: true, message: "请输入退款原因", trigger: "blur"}
        ],
      },
      referralOptions: [],//选择渠道号列表
      isRemoveAllTag: 0,//下拉框是否清空
      today_recharge_money:0,//今日充值金额
      monthly_recharge_money:0,//当月充值金额
      total_recharge_money:0,//总充值
    };
  },

  created() {
    this.getCreatedAt();
    // // 接收地址栏参数
    this.getUrlParams();
    this.getOrderList();
    this.getAppList();
    this.getSelectReferral();
  },
  methods: {
    // 计算列合计（表格底部）
                getSummaries(param) {
                    const { columns, data } = param;
                    const sums = [];
                    columns.forEach((column, index) => {
                        if (index === 0) {
                            sums[index] = '总计';
                            return;
                        } else if (index == 8) {
                          const values = data.map((item) => Number(item['money']));
                          console.log(column,'循环数据');
                          
                           if (!values.every(value => isNaN(value))) {
                                sums[index] = values.reduce((prev, curr) => {
                                    const value = Number(curr);
                                    if (!isNaN(value)) {
                                        return prev + curr;
                                    } else {
                                        return prev;
                                    }
                                }, 0);
                                sums[index] = sums[index].toFixed(2);
                            } else {
                                sums[index] = '-';
                            }
                        }
                        else
                        {
                          sums[index] = '-';
                        }
                        // if (index === 5 || index === 6) {
                        //     sums[index] = '-';
                        //     return;
                        // }
                        // const values = data.map(item => Number(item[column.property]));
                       
                    });

                    return sums;
                },
    /**
     * 选择渠道号
     */
    selectedReferral(value) {
      this.queryParams.channel_code = value;
    },
    /**
     * 获取选择渠道号列表
     */
    getSelectReferral() {
      const api = GeneralCollectApi();
      api.getSelectReferral()
          .then((res) => {
            if (res.code == 0) {
              let data = res.data;
              this.referralOptions = data.map(item => ({
                value: item.channel_code,
                label: item.channel_code,
                label_en: item.movie_name + '-' + item.episodes_name + '-' + item.channel_name,
                check: false
              }));
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    },

    getCreatedAt() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      const time = '00:00:00';
      const times = '23:59:59';
      const formattedDate = `${year}-${month}-${day} ${time}`;
      const formattedDates = `${year}-${month}-${day} ${times}`;
      this.queryParams.created_at = [formattedDate, formattedDates];
      this.daochuList.created_at = [formattedDate, formattedDates];
    },
    refund(row) {
      this.formRefund = {}
      this.formRefund.id = row.id
      this.dialogFormVisible = true;
    },
    bcbtn(row)
    {
      const api = OrderApi();
      let arr = {
        id:row.id
      }
      api.postOrderCallback(arr)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
              });
              this.getOrderList();
            } else {
              processErrors(res);
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
    },

    /**
     * 提交退款操作
     */
    submitFormRefund() {
      const api = OrderApi();
      api.refundByte(this.formRefund).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.data,
            type: 'success',
          });
          this.dialogFormVisible = false;
          this.getOrderList();
        } else {
          processErrors(res);
        }
      }).catch((error) => {
        this.loading = false;
      });
    },

    getUrlParams() {
      var channelCode = this.$route.query.channel_code;
      if (channelCode) {
        this.queryParams.channel_code = channelCode;
      }
    },
    search() {
      this.getOrderList();
    },
    handTimeZhuce(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      const time = '00:00:00';
      const formattedDate = `${year}-${month}-${day} ${time}`;

      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2);
      const times = '23:59:59';
      const formattedDates = `${years}-${months}-${days} ${times}`;
      this.queryParams.user_createtime = [formattedDate, formattedDates];
      this.getOrderList();
    },
    handTimeSucces(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      const time = '00:00:00';
      const formattedDate = `${year}-${month}-${day} ${time}`;
      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2);
      const times = '23:59:59';
      const formattedDates = `${years}-${months}-${days} ${times}`;
      this.queryParams.finistime = [formattedDate, formattedDates];
      this.getOrderList();
    },
    handTime(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      const time = '00:00:00';
      const formattedDate = `${year}-${month}-${day} ${time}`;

      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2);
      const times = '23:59:59';
      const formattedDates = `${years}-${months}-${days} ${times}`;

      this.queryParams.created_at = [formattedDate, formattedDates];
      this.getOrderList();
    },
    addNoNe() {
      this.isRemoveAllTag += 1;
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        trade_no: '',
        order_id: '',
        payment_order_no: '',
        money: '',
        state: '',
        platform_type: '',
        app_id: '',
        optimizer_id: '',
        optimizer_nickname: '',
        channel_code: [],
        user_id: '',
        ad_id: '',
        user_createtime: [],
        created_at: [],
        finistime: [],
        refund: '',
      };
      this.getCreatedAt();
      this.getOrderList();
    },
    //导出事件按钮
    // addList(){
    //   const api = OrderApi();
    //   let params = this.queryParams
    //   api
    //       .getOrderexport(params)
    //       .then((res) => {
    //         console.log(res)
    //         // 创建一个Blob对象
    //         // const blob = new Blob([res])
    //         // // 创建一个指向该Blob的URL
    //         // const url = window.URL.createObjectURL(blob)
    //         // // 创建一个a标签
    //         // const link = document.createElement('a')
    //         // link.href = url
    //         // // 设置下载文件名，如果后端在Content-Disposition头中提供了文件名，可以从中解析，这里假设固定
    //         // link.download = '订单明细.xlsx'
    //         // document.body.appendChild(link)
    //         // link.click()
    //         // // 清理
    //         // window.URL.revokeObjectURL(url)
    //         // document.body.removeChild(link)
    //       })
    //       .catch((error) => {
    //         console.error('导出失败', error)
    //       });
    // },
    addList() {
      const params = {...this.queryParams};
      const urlParams = new URLSearchParams();
      // 处理其他参数
      Object.keys(params).forEach((key) => {
        if (params[key] && key !== 'pageNo' && key !== 'pageSize' && key !== 'user_createtime' && key !== 'created_at' && key !== 'finistime') {
          urlParams.append(key, params[key]);
        }
      });
      // 处理 created_at 参数
      if (params.created_at && Array.isArray(params.created_at)) {
        params.created_at.forEach((date) => {
          urlParams.append('created_at[]', date);
        });
      }
      // 处理 created_at 参数
      if (params.user_createtime && Array.isArray(params.user_createtime)) {
        params.user_createtime.forEach((date) => {
          urlParams.append('user_createtime[]', date);
        });
      } // 处理 created_at 参数
      if (params.finistime && Array.isArray(params.finistime)) {
        params.finistime.forEach((date) => {
          urlParams.append('finistime[]', date);
        });
      }
      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if (token !== null) {
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
      // 获取基础 URL
      const baseExportUrl = 'https://backend.bakaba.cn/admin/order/export';
      console.log(baseExportUrl,'获取基础 URL')
      // 拼接 URL 参数
      const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
      console.log(fullExportUrl,'拼接 URL 参数')
      // return false
      window.location.href = fullExportUrl;
    },

    getAppList() {
      const api = appListAPI();
      let params = {
        status: 1,
      };
      api
          .getAppList(params)
          .then((res) => {
            if (res.code == 0) {
              this.appList = this.appList.concat(res.data);
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
            this.loading = false;
          });
    },

    handleClose(done) {
      done();
      this.$refs['ruleForm'].resetFields();
    },
    addSearch() {
      this.SearchFlag = !this.SearchFlag;
    },
    getOrderList() {
      this.loading = true;
      const api = OrderApi();
      api.getOrderList(this.queryParams)
          .then((res) => {
            if (res.code == 0) {
              this.tableData = res.data.data;
              this.total = res.data.totalCount;
              this.monthly_recharge_money = res.data.monthly_recharge_money
              this.today_recharge_money = res.data.today_recharge_money
              this.total_recharge_money = res.data.total_recharge_money
            } else {
              processErrors(res);
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
    },
    handleSelectionChange(val) {
    },
    //修改
    handleUpdate() {
    },
    //删除
    handleDel() {
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
.hz_all{
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
 
}
 .hz_left{
    width: 33%;
    min-height:100px;
    border: 1px solid #eeeeee;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .titleText{
    color: #000000;
    font-size: 16px;
  }
  .moneyText{
     color: #409eff;
    font-size: 14px;
    margin-top: 10px;
  }
</style>
